import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Layout = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 0;
`;

export const Wrapper = styled.div`
  background-color: var(--modal-snow-background-color, var(--snow));
  border-radius: 2px;
  color: var(--modal-night-color, var(--night));
  z-index: 9;
  padding: 32px;
  box-sizing: border-box;
  width: 100%;
  min-height: 570px;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 54px;

  > span {
    position: absolute;
    right: 0;
  }
`;

export const AddIntegrationTitle = styled(Typography.Title)`
  position: absolute;
  left: 0;
  line-height: inherit;
  margin-bottom: 32px;
`;

export const IntegrationTitle = styled(Typography.Title)`
  margin: 0 0 32px;
  text-align: center;
`;

export const Content = styled.div`
  form {
    display: block;
    max-width: 520px;
    margin: 0 auto;

    > footer {
      justify-content: center;
    }
  }
`;
